(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4223],{

/***/ 5489:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/diversity/commitment",
      function () {
        return __webpack_require__(6657);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ SimpleCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6010);
/* harmony import */ var tailwind_override__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1182);
/* harmony import */ var tailwind_override__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(tailwind_override__WEBPACK_IMPORTED_MODULE_1__);



const BG_COLOR_CLASSES = {
    white: "bg-white",
    black: "bg-hrg-black-90 text-white"
};
const SimpleCard = (param)=>/*#__PURE__*/ {
    let { className , children , color ="white"  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,tailwind_override__WEBPACK_IMPORTED_MODULE_1__.overrideTailwindClasses)((0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("p-6 rounded-5xl", BG_COLOR_CLASSES[color], className)),
        children: children
    });
};


/***/ }),

/***/ 6566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ LevelThreeHero; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var components_atoms_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1280);


const LevelThreeHero = (param)=>/*#__PURE__*/ {
    let { header  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "content-wrapper",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "h3 max-w-[840px]",
                children: header.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "items-center mt-6 mb-16 laptop:flex laptop:items-center laptop:mx-auto tablet:mb-20 laptop:mb-28",
                children: [
                    header.ingress && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "ingress max-w-[744px] mt-6",
                        children: header.ingress
                    }),
                    header.cta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        iconPosition: "right",
                        href: header.cta.href,
                        className: "inline-flex mt-8 laptop:mt-0 laptop:ml-16 laptop:flex-shrink-0",
                        children: header.cta.text
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 2266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ ScrollableCardGrid; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_is__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9864);
/* harmony import */ var tailwind_override__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1182);
/* harmony import */ var tailwind_override__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(tailwind_override__WEBPACK_IMPORTED_MODULE_3__);





const ScrollableCardGrid = (param)=>/*#__PURE__*/ {
    let { children , className  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,tailwind_override__WEBPACK_IMPORTED_MODULE_3__.overrideTailwindClasses)((0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("flex px-6 -mx-6 overflow-x-scroll laptop:gap-x-6 laptop:px-0 laptop:-mx-0 laptop:overflow-x-visible snap-x scrollbar-hide laptop:grid laptop:grid-cols-3 laptop:gap-y-12", className)),
        children: react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, (child)=>{
            const scrollableClassName = "w-11/12 max-w-[360px] laptop:max-w-[unset] shrink-0 laptop:w-full snap-start scroll-m-6 mr-6 last:m-0";
            if (react_is__WEBPACK_IMPORTED_MODULE_2__.isElement(child)) {
                const props = child.props;
                const childClassName = props.className;
                return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(child, {
                    className: (0,tailwind_override__WEBPACK_IMPORTED_MODULE_3__.overrideTailwindClasses)((0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(scrollableClassName, childClassName))
                });
            }
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,tailwind_override__WEBPACK_IMPORTED_MODULE_3__.overrideTailwindClasses)((0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("h-full", scrollableClassName)),
                children: child
            });
        })
    });
};


/***/ }),

/***/ 3189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ ContentNavigationList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/components/molecules/ScrollableCardGrid.tsx
var ScrollableCardGrid = __webpack_require__(2266);
;// CONCATENATED MODULE: ./src/types/contentful/Items/ContentNavigationItem.ts
const isContentNavigationSingle = (item)=>item.type === "single";

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/tailwind-override/lib/index.js
var lib = __webpack_require__(1182);
// EXTERNAL MODULE: ./src/components/atoms/StyledLink.tsx
var StyledLink = __webpack_require__(7169);
// EXTERNAL MODULE: ./src/components/atoms/SimpleCard.tsx
var SimpleCard = __webpack_require__(2766);
;// CONCATENATED MODULE: ./src/components/molecules/ContentNavigationCardMultiple.tsx





const ContentNavigationCardMultiple = (param)=>/*#__PURE__*/ {
    let { className , content  } = param;
    return (0,jsx_runtime.jsxs)(SimpleCard/* SimpleCard */.s, {
        color: "black",
        className: (0,lib.overrideTailwindClasses)((0,clsx_m/* default */.Z)("pt-8", className)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "mb-5 h5",
                children: content.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: content.links.map((link)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "mb-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink/* StyledLink */.F, {
                            link: link
                        })
                    }, link.href + link.text))
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/atoms/Button.tsx
var Button = __webpack_require__(1280);
// EXTERNAL MODULE: ./src/constants/ButtonModes.ts
var ButtonModes = __webpack_require__(9413);
;// CONCATENATED MODULE: ./src/components/molecules/ContentNavigationCardSingle.tsx






var _intro;
const ContentNavigationCardSingle = (param)=>/*#__PURE__*/ {
    let { className , headerTag: Header = "h3" , content  } = param;
    return (0,jsx_runtime.jsxs)(SimpleCard/* SimpleCard */.s, {
        color: "black",
        className: (0,lib.overrideTailwindClasses)((0,clsx_m/* default */.Z)("flex flex-col pt-8", className)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                className: "mb-5 h5",
                children: content.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mb-10",
                children: content.intro
            }),
            content.link && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: "mt-auto w-fit",
                size: "small",
                mode: ButtonModes/* ButtonModes.secondaryWhite */.r.secondaryWhite,
                href: content.link.href,
                "aria-label": (_intro = content.intro) !== null && _intro !== void 0 ? _intro : undefined,
                children: content.link.text
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/ContentNavigationList.tsx





const ContentNavigationList = (param)=>/*#__PURE__*/ {
    let { contentNavigationItems  } = param;
    return (0,jsx_runtime.jsx)("section", {
        className: "py-12 bg-black tablet:pt-18 laptop:pt-20 tablet:pb-18 laptop:pb-20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "content-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableCardGrid/* ScrollableCardGrid */.$, {
                children: contentNavigationItems.map((item)=>isContentNavigationSingle(item) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentNavigationCardSingle, {
                        content: item
                    }, item.id) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentNavigationCardMultiple, {
                        content: item
                    }, item.id))
            })
        })
    });
};


/***/ }),

/***/ 1877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ ChapteredSubPageView; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6010);
/* harmony import */ var components_organisms_ViewMain__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6644);
/* harmony import */ var components_organisms_ContentBody__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2917);
/* harmony import */ var components_molecules_LevelThreeHero__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6566);
/* harmony import */ var components_molecules_PageMeta__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6416);
/* harmony import */ var utils_openGraph__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4568);
/* harmony import */ var utils_contentBody__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9657);
/* harmony import */ var components_organisms_ContentNavigationList__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3189);









const CHAPTER_BACKGROUNDS = [
    "bg-hrg-",
    "bg-hrg-black-5"
];
var ref;
const ChapteredSubPageView = (param)=>{
    let { content , title  } = param;
    var ref1;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_organisms_ViewMain__WEBPACK_IMPORTED_MODULE_1__/* .ViewMain */ .h, {
        footerMargin: false,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_molecules_PageMeta__WEBPACK_IMPORTED_MODULE_4__/* .PageMeta */ .V, {
                title: title,
                header: content.header,
                openGraph: {
                    image: (0,utils_openGraph__WEBPACK_IMPORTED_MODULE_6__/* .mapImageContentToOpenGraph */ .k)((0,utils_contentBody__WEBPACK_IMPORTED_MODULE_7__/* .extractFirstImageFromContentBody */ .f)((ref = (ref1 = content.chapters.at(0)) === null || ref1 === void 0 ? void 0 : ref1.body) !== null && ref !== void 0 ? ref : []))
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_molecules_LevelThreeHero__WEBPACK_IMPORTED_MODULE_3__/* .LevelThreeHero */ .J, {
                header: content.header
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: content.chapters.map((chapter, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)("pt-16 first:pt-0", CHAPTER_BACKGROUNDS[index % 2]),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "mb-10 h5 content-wrapper",
                                children: chapter.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_organisms_ContentBody__WEBPACK_IMPORTED_MODULE_2__/* .ContentBody */ .z, {
                                body: chapter.body,
                                className: "pb-16 mb-0 tablet:mb-0 tablet:pb-28"
                            })
                        ]
                    }, chapter.id))
            }),
            content.contentNavigation && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_organisms_ContentNavigationList__WEBPACK_IMPORTED_MODULE_5__/* .ContentNavigationList */ .e, {
                contentNavigationItems: content.contentNavigation.cards
            })
        ]
    });
};


/***/ }),

/***/ 6657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var components_views_ChapteredSubPageView__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1877);


const DEICommitmentPage = (param)=>/*#__PURE__*/ {
    let { content  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_views_ChapteredSubPageView__WEBPACK_IMPORTED_MODULE_1__/* .ChapteredSubPageView */ .h, {
            title: "Our Commitment",
            content: content
        })
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (DEICommitmentPage);


/***/ }),

/***/ 9657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ extractFirstImageFromContentBody; }
/* harmony export */ });
/* unused harmony export extractTextFromContentBody */

const extractFirstImageFromContentBody = (body)=>{
    const firstImageSection = body.find((item)=>item.__typename === "GroupedImagesSection" || item.__typename === "VideoSection");
    if ((firstImageSection === null || firstImageSection === void 0 ? void 0 : firstImageSection.__typename) === "GroupedImagesSection") {
        var ref;
        return (ref = firstImageSection.images.at(0)) !== null && ref !== void 0 ? ref : null;
    }
    if ((firstImageSection === null || firstImageSection === void 0 ? void 0 : firstImageSection.__typename) === "VideoSection") {
        var _fallbackImage;
        return (_fallbackImage = firstImageSection.fallbackImage) !== null && _fallbackImage !== void 0 ? _fallbackImage : null;
    }
    return null;
};
const extractTextFromContentBody = (body)=>{
    const firstText = body.find((item)=>item.__typename === "RichText");
    if ((firstText === null || firstText === void 0 ? void 0 : firstText.__typename) === "RichText") {
        const text = extractTextFromRichText(firstText.text);
        return text;
    }
    return null;
};


/***/ }),

/***/ 9921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}__webpack_unused_export__=h;__webpack_unused_export__=g;__webpack_unused_export__=b;__webpack_unused_export__=l;__webpack_unused_export__=d;__webpack_unused_export__=q;__webpack_unused_export__=p;__webpack_unused_export__=c;__webpack_unused_export__=f;__webpack_unused_export__=e;__webpack_unused_export__=m;
__webpack_unused_export__=n;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return v(a)===h};__webpack_unused_export__=function(a){return v(a)===g};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return v(a)===l};__webpack_unused_export__=function(a){return v(a)===d};__webpack_unused_export__=function(a){return v(a)===q};__webpack_unused_export__=function(a){return v(a)===p};
__webpack_unused_export__=function(a){return v(a)===c};__webpack_unused_export__=function(a){return v(a)===f};__webpack_unused_export__=function(a){return v(a)===e};__webpack_unused_export__=function(a){return v(a)===m};__webpack_unused_export__=function(a){return v(a)===n};
__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};__webpack_unused_export__=v;


/***/ }),

/***/ 9864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(9921);
} else {}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6731,5872,6644,6656,9774,2888,179], function() { return __webpack_exec__(5489); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);